/**
 * Types pour les profils professionnels (Infirmiere / Infirmiere Auxiliaire)
 */

export type ProfessionalType = 'INF' | 'INF_AUX';

export interface ProfessionalProfile {
  type: ProfessionalType;
  label: string;
  description: string;
  allowedModules: string[];
  allowedProfiles: string[];
}

export const PROFESSIONAL_PROFILES: Record<ProfessionalType, ProfessionalProfile> = {
  INF: {
    type: 'INF',
    label: 'Infirmiere',
    description: "Acces complet a tous les modules d'evaluation et soins",
    allowedModules: ['*'], // Tous les modules
    allowedProfiles: ['*'], // Tous les profils de visite
  },
  INF_AUX: {
    type: 'INF_AUX',
    label: 'Infirmiere auxiliaire',
    description: 'Acces aux signes vitaux, douleur, fonctions de base et soins essentiels',
    allowedModules: [
      'informations-generales',
      'signes-vitaux',
      'douleur-v2',
      'fonctions_base',
      'sonde-urinaire',
      'soins-plaie-simple',
      'nephrostomie-v2',
      'soins-poc-v2',
      'soins-de-stomie-v2',
      'catheterisme-vesical-v2',
    ],
    allowedProfiles: [
      'aux-soins-plaie',
      'aux-stomie',
      'aux-sonde-urinaire',
      'aux-catheterisme',
      'aux-nephrostomie',
    ],
  },
};

/**
 * Verifie si un module est accessible pour un type professionnel
 */
export function canAccessModule(professionalType: ProfessionalType, moduleId: string): boolean {
  const profile = PROFESSIONAL_PROFILES[professionalType];
  return profile.allowedModules.includes('*') || profile.allowedModules.includes(moduleId);
}

/**
 * Verifie si un profil de visite est accessible pour un type professionnel
 */
export function canAccessVisitProfile(
  professionalType: ProfessionalType,
  profileId: string
): boolean {
  const profile = PROFESSIONAL_PROFILES[professionalType];
  return profile.allowedProfiles.includes('*') || profile.allowedProfiles.includes(profileId);
}
